import { useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Radio,
  RadioGroup,
  Spinner,
  Stack,
  Tab,
  Table,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { Field, Form } from "react-final-form";
import { useUserList } from "../../home/hooks";
import { useVehicleList } from "../../vehicle/hooks";
import { formatRequest, header, validate } from "../helpers";
import { usePushList } from "../hooks";
import {
  CustomMultiSelect,
  CustomCheckbox,
  CustomInput,
  CustomTextArea,
} from "../../customComponents/components";
import { PageHead } from "../../home/components/PageHead";
import { TableHead } from "../../home/components/TableHead";
import { DonwloadComponent } from "../../customComponents/components/CustomInput/CustomInput";

export const PushScreen = () => {
  const [radioValue, setRadioValue] = useState("users");
  const { pushList, pushDeleteReq, pushAddReq, pushListLoading } =
    usePushList();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabsChange = (index) => {
    setTabIndex(index);
  };

  const { userList } = useUserList();
  const { vehiclesList } = useVehicleList();

  const userOptions = userList.map(({ id, name }) => ({
    value: id,
    label: name,
  }));
  const vehicleOptions = vehiclesList.map(({ id, title }) => ({
    value: id,
    label: title,
  }));

  return (
    <PageHead breadCrumbs={<Heading>Push - уведомления</Heading>}>
      <Tabs index={tabIndex} onChange={handleTabsChange}>
        <TabList>
          <Tab>Список ручных уведомлений</Tab>
          <Tab>Список системных уведомлений</Tab>
          <Tab>Отправка push-уведомления</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            {pushListLoading ? (
              <Container height="calc(100vh - 240px)">
                <Spinner
                  position={"absolute"}
                  top="50%"
                  right="50%"
                  size="xl"
                />
              </Container>
            ) : (
              <TableHead column={header}>
                {pushList
                  ?.filter((p) => p.manual)
                  .map(({ description, id, image, reciever, title }) => (
                    <Tr key={id}>
                      <Td>
                        <Text fontSize="sm" color="#121419">
                          {id}
                        </Text>
                      </Td>
                      <Td>
                        <Text fontSize="sm" color="#121419">
                          {title || "Отсутствует"}
                        </Text>
                      </Td>
                      <Td>
                        <Text fontSize="sm" color="#121419">
                          {description || "Отсутствует"}
                        </Text>
                      </Td>
                      {/* <Td>
                        {image || (
                          <Text fontSize="sm" color="#121419">
                            Изображение отсутствует
                          </Text>
                        )}
                      </Td> */}
                      <Td>
                        <Text fontSize="sm" color="#121419">
                          {reciever}
                        </Text>
                      </Td>
                      <Td>
                        <Button
                          colorScheme="red"
                          onClick={() => pushDeleteReq({ id })}
                        >
                          Удалить
                        </Button>
                      </Td>
                    </Tr>
                  ))}
              </TableHead>
            )}
          </TabPanel>
          <TabPanel>
            {pushListLoading ? (
              <Container height="calc(100vh - 240px)">
                <Spinner
                  position={"absolute"}
                  top="50%"
                  right="50%"
                  size="xl"
                />
              </Container>
            ) : (
              <TableHead column={header}>
                {pushList
                  ?.filter((p) => !p.manual)
                  ?.map(({ description, id, image, reciever, title }) => (
                    <Tr key={id}>
                      <Td>
                        <Text fontSize="sm" color="#121419">
                          {id}
                        </Text>
                      </Td>
                      <Td>
                        <Text fontSize="sm" color="#121419">
                          {title || "Отсутствует"}
                        </Text>
                      </Td>
                      <Td>
                        <Text fontSize="sm" color="#121419">
                          {description || "Отсутствует"}
                        </Text>
                      </Td>
                      {/* <Td>
                        {image || (
                          <Text fontSize="sm" color="#121419">
                            Изображение отсутствует
                          </Text>
                        )}
                      </Td> */}
                      <Td>
                        <Text fontSize="sm" color="#121419">
                          {reciever}
                        </Text>
                      </Td>
                      <Td>
                        <Button
                          colorScheme="red"
                          onClick={() => pushDeleteReq({ id })}
                        >
                          Удалить
                        </Button>
                      </Td>
                    </Tr>
                  ))}
              </TableHead>
            )}
          </TabPanel>
          <TabPanel>
            <Form
              mutators={{
                setValue: ([field, value], state, { changeValue }) => {
                  changeValue(state, field, () => value);
                },
              }}
              onSubmit={(values) => {
                // ---------------------
                console.log("values", {
                  ...values,
                  id: pushList.length + 1,
                  reciever: values.reciever.all
                    ? "all"
                    : {
                        vehicles_id: values.reciever.vehicles_id,
                        users: values.reciever.users,
                      },
                });
                // ---------------------
                pushAddReq({
                  ...values,
                  manual: true,
                  reciever: values.reciever.all
                    ? "all"
                    : JSON.stringify({
                        vehicles_id: formatRequest(values.reciever.vehicles_id),
                        users: formatRequest(values.reciever.users),
                      }),
                });
                setTabIndex(0);
              }}
              initialValues={{
                title: "",
                description: "",
                reciever: { all: false, users: [], vehicles_id: [] },
                image: null,
              }}
              validate={(values) => validate(values, radioValue)}
              render={({
                form,
                handleSubmit,
                submitting,
                pristine,
                values,
              }) => {
                //@ts-ignore
                window.form = form;
                return (
                  <form onSubmit={handleSubmit}>
                    <Heading as="h3" size="md">
                      Создание уведомления
                    </Heading>
                    <Box marginTop={"40px"}>
                      <FormControl>
                        <FormLabel>Получатели</FormLabel>
                        <Flex gap={2} alignItems="center" marginTop={"20px"}>
                          <Text fontSize="lg">Все</Text>
                          <Field
                            name="reciever.all"
                            component={CustomCheckbox}
                            type="checkbox"
                            size="lg"
                          />
                        </Flex>{" "}
                        <Box>
                          <RadioGroup
                            isDisabled={values.reciever.all}
                            onChange={setRadioValue}
                            value={radioValue}
                            marginTop={"20px"}
                          >
                            <Stack direction="row">
                              <Radio value="users">Клиенты</Radio>
                              <Radio value="vehicles_id">Автомобили</Radio>
                            </Stack>
                          </RadioGroup>
                          <Box marginTop={"20px"} maxWidth="500px">
                            {radioValue === "users" && (
                              <Field
                                isDisabled={values.reciever.all}
                                name="reciever.users"
                                placeholder="Клиенты"
                                label="Клиенты"
                                component={CustomMultiSelect}
                                options={userOptions}
                              />
                            )}
                            {radioValue === "vehicles_id" && (
                              <Field
                                isDisabled={values.reciever.all}
                                name="reciever.vehicles_id"
                                placeholder="Автомобили"
                                label="Автомобили"
                                component={CustomMultiSelect}
                                options={vehicleOptions}
                              />
                            )}
                          </Box>
                        </Box>
                      </FormControl>
                    </Box>
                    <Divider marginTop={"20px"} marginBottom={"20px"} />
                    <Box flex="1">
                      <FormControl>
                        <Field
                          name="title"
                          placeholder="Заголовок"
                          label="Заголовок"
                          component={CustomInput}
                          type="text"
                        />
                      </FormControl>
                    </Box>
                    <Divider marginTop={"20px"} marginBottom={"20px"} />
                    <Box>
                      <FormControl>
                        <Field
                          name="description"
                          placeholder="Описание"
                          label="Описание"
                          component={CustomTextArea}
                          type="text"
                        />
                      </FormControl>
                    </Box>
                    <Divider marginTop={"20px"} marginBottom={"20px"} />

                    {/* <Box maxWidth="300px">
                      <DonwloadComponent label={"Изображение"} name={"image"} />
                    </Box>
                    <Divider marginTop={"20px"} marginBottom={"20px"} /> */}

                    <Button
                      type="submit"
                      marginTop={"40px"}
                      colorScheme="teal"
                      variant="outline"
                      // size="lg"
                    >
                      Отправить
                    </Button>
                  </form>
                );
              }}
            ></Form>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </PageHead>
  );
};
